import { Tag } from 'antd'
import PropTypes from 'prop-types'

const ShowOrHideAction = ({ status }) => {
	return (
		<div>
			<Tag
				color={status === 'show' ? 'green' : 'red'}
				key={status}
				// onClick={handleClick}
			>
				{status === 'show' ? 'Show' : 'Hiden'}
			</Tag>
		</div>
	)
}

ShowOrHideAction.propTypes = {
	onClick: PropTypes.func,
	status: PropTypes.any,
	record: PropTypes.any,
}

export default ShowOrHideAction
